import { createSelector } from '@reduxjs/toolkit'
import { CARD_DATA_REFRESH_INTERVAL_MS } from '@shared-core/config/polling'
import type { ModelBackendCard, ModelCardTemplate, ModelCardTemplateId } from '@shared-core/features/backend/models'
import { storeKey } from '@shared-core/features/backend/slice'
import type { AppState } from '@shared-core/store/types'

const selectBackendState = (state: AppState) => state[storeKey]

export const selectedBanks = createSelector(selectBackendState, (state) => state.banks)

export const selectedCards = createSelector(selectBackendState, (state) => state.cards)
export const selectedCardsLoading = createSelector(selectBackendState, (state) => state.isCardsLoading)
export const selectedTransactions = createSelector(selectBackendState, (state) => state.transactions)
export const selectedCardIssue = createSelector(selectBackendState, (state) => state.cardIssue)
export const selectedCardTopupLoading = createSelector(selectBackendState, (state) => state.isCardTopupLoading)
export const selectedCardBlockPreparations = createSelector(selectBackendState, (state) => state.cardBlockPreparations)
export const selectedCardBlockPreparing = createSelector(selectBackendState, (state) => state.cardBlockPreparing)
export const selectedEmailPromptShown = createSelector(selectBackendState, (state) => state.emailPromptShown)
export const selectedCurrentUser = createSelector(selectBackendState, (state) => state.user)

const EMPTY_CARD_TEMPLATES: ModelCardTemplate[] = []

export const selectedCardTemplates = createSelector(
  selectBackendState,
  (state) => state.cardTemplates ?? EMPTY_CARD_TEMPLATES,
)

// Период обновления карт и операций: минимальный validTime шаблонов в мс.
export const selectedCardTemplatesValidTimeMs = createSelector(selectedCardTemplates, (templates) =>
  templates.length
    ? Math.min(...templates.map((template) => template.rates.validTime)) * 1000
    : CARD_DATA_REFRESH_INTERVAL_MS,
)

export function isIssuedCard(card: ModelBackendCard): boolean {
  return !['pending', 'processing', 'failed'].includes(card.status)
}

export function matchesCardTemplate(card: ModelBackendCard, templateId: ModelCardTemplateId): boolean {
  return card.templateId === templateId || card.type === templateId
}
